import get from 'lodash/get';
import { http } from '@pendo/http';

export const LAUNCH_METHODS = Object.freeze({
    apiDA: {
        label: 'No Activation',
        text: "This guide has no activation method selected. It won't be displayed to your users"
    },
    apiReseller: {
        label: 'Launched via API',
        text:
            'This activation setting is the result of not selecting any other type. This guide can still be activated programmatically'
    },
    auto: {
        label: 'Automatic',
        text: 'once automatically, until dismissed or advanced'
    },
    badge: {
        label: 'Badge',
        text: 'after a visitor clicks the badge icon'
    },
    confirmation: {
        label: 'Confirmation',
        text: 'when confirmation element is clicked'
    },
    extensionIcon: {
        label: 'Pendo Launcher',
        text: 'when the Pendo Launcher icon is clicked'
    },
    dom: {
        label: 'Element Click',
        text: 'when target element is clicked'
    },
    launcher: {
        label: 'Resource Center',
        text: 'in the Resource Center'
    }
});

export const MATCH_TYPES_TO_TEXT_MAP = {
    contains: 'contains',
    notContains: 'does not contain',
    equal: 'exactly matches',
    notEqual: 'does not match',
    greaterThan: 'is greater than',
    lessThan: 'is less than'
};

export function isBadgeGuide (guide) {
    return guide.launchMethod.includes('badge');
}

export function isConfirmationGuide (guide) {
    return isBadgeGuide(guide) && !!get(guide, 'attributes.badge.isConfirmation');
}

export function constructLaunchMethodString (launchMethod, automaticActivation) {
    let launchMethods = launchMethod.split('-');
    if (automaticActivation) {
        launchMethods.unshift('auto');
        launchMethods = launchMethods.filter((method) => method !== 'api');
    } else {
        launchMethods = launchMethods.filter((method) => method !== 'auto');
    }
    if (launchMethods.length === 0) launchMethods.push('api');

    return launchMethods.join('-');
}

export function getBuildingBlocks (step) {
    return Promise.all([
        http.get(step.buildingBlocksUrl, { withCredentials: false }).then((res) => res.data),
        http.get(step.domUrl, { withCredentials: false }).then((res) => res.data)
    ]).then(([buildingBlocks, dom]) => {
        return {
            buildingBlocks: JSON.stringify(buildingBlocks),
            dom: JSON.stringify(dom)
        };
    });
}

export async function getStepsWithBuildingBlocks ({ steps }) {
    const stepsContent = await Promise.all(steps.map((step) => getBuildingBlocks(step)));

    stepsContent.forEach((buildingBlocksAndDom, index) => {
        steps[index] = { ...steps[index], ...buildingBlocksAndDom };
    });

    return steps;
}

export function entityIdToNameMap (entities) {
    return entities.reduce((total, curr) => {
        total[curr.id] = curr.displayName || curr.name;

        return total;
    }, {});
}

export function addPropertyNamesToSteps (steps, featureNamesById, pagesNamesById) {
    return steps.map((step) => {
        const featureId = step?.featureId || step?.locationFeatureId;
        const featureName = featureNamesById[featureId];
        if (featureName) {
            step.featureName = featureName;
        }

        const pageName = pagesNamesById[step?.pageId];
        if (pageName) {
            step.pageName = pageName;
        }

        return step;
    });
}
